<template>
  <b-card header="Shipping Rates" style="min-height: 400px;">
    <section v-if="showLoader" class="card-loader">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </section>
    <b-row class="align-items-center" style="height: 100%;">
      <b-col>
        <b-row class="font-weight-bold mb-1">
          <b-col cols="5">
            Service
          </b-col>
          <b-col>
            Website
          </b-col>
          <b-col>
            Discounted
          </b-col>
          <b-col>
            Retail
          </b-col>
        </b-row>
        <b-row v-for="rate, ix in rates" :key="ix" class="mb-3 align-items-center">
          <b-col cols="5">
            <div :style="rateColor(rate.carrier)">

              {{rate.service}}</div>
            <div style="line-height: 80%;" v-if="rate.delivery_days && rate.carrier != 'DHLExpress'">
              <span class="small">{{rate.delivery_days}} day ship</span>
              <em v-if="rate.delivery_date" class="small"><br>by <NiceDate :value="rate.delivery_date" :isUtc="true"/></em>
            </div>
          </b-col>
          <b-col>
            ${{ rate.quote.web && rate.quote.web > 0 ? rate.quote.web.toFixed(2) : ' -'}}
          </b-col>
          <b-col>
            ${{ rate.quote.discount && rate.quote.discount > 0 ? rate.quote.discount.toFixed(2) : ' -' }}
          </b-col>
          <b-col>
            ${{ rate.quote.retail && rate.quote.retail > 0 ? rate.quote.retail.toFixed(2) : ' -' }}
          </b-col>
        </b-row>
      </b-col>

    </b-row>
    <div slot="footer">
      <div class="row">
        <div class="col-10">
          <b-button
            :variant="invalid ? 'danger' : 'success'"
            :disabled="invalid"
            @click="quote()"
            block
          >
            Get Rates
          </b-button>
        </div>
        <div class="col-2">
          <b-button
            variant="info"
            :disabled="shipment_ids.length == 0"
            @click="$refs.shipment_id_modal.show()"
            block
          >
            Get EP IDs
          </b-button>
        </div>
      </div>
    </div>

    <b-modal ref="shipment_id_modal" title="EasyPost Shipment IDs">
      <ul>
        <li v-for="ship in this.shipment_ids" :key="ship">{{ship}}</li>
      </ul>
    </b-modal>

  </b-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ShippingService from '../../services/shipping';
import NiceDate from '../utility/NiceDate';

// hardcoded, taken from EasyPost (2025-01-10)
const SMALL_FLAT_RATE_RETAIL = 11.00;
const SMALL_FLAT_RATE_DISCOUNT = 9.21;

export default {
  name: "Rates",
  components: {
    NiceDate,
  },
  props: {
    packages: { type: Array, default: [] },
    rates: { type: Array, default: [] },
    destination: { type: Object },
    loading: { type: Boolean, default: false },
    invalid: { type: Boolean, default: true },
    shipment_ids: { type: Array, default: () => { return [] } },
  },
  data() {
    return {
      amILoading: false,
    }
  },
  computed: {
    ...mapGetters({
      workareaShippingServices: 'workareaShippingServices',
    }),
    showLoader() {
      return this.loading || this.amILoading;
    },
  },
  mounted() {
    this.getWorkareaShippingServices();
  },
  methods: {
    ...mapActions({
      getWorkareaShippingServices: 'getWorkareaShippingServices',
    }),
    rateColor(carrier) {
      let backgroundColor = ""
      let color = ""

      if (carrier == "FedEx") {
        backgroundColor = "#51A917"
        color = "white"
      } else if (carrier == "DHLExpress"){
        backgroundColor = "red"
        color = "white"
      } else if (carrier == "USPS"){
        backgroundColor = "orange"
        color = "white"
      } else {
        backgroundColor = "#A836FF"
        color = "white"
      }
      return ({backgroundColor, color, padding: "2px"})
    },
    quote() {
      this.amILoading = true;
      while(this.rates.length > 0) { this.rates.pop(); }
      ShippingService.getRates({destination: this.destination, packages: this.packages}).then( d => {
        if(d.error) {
          console.warn(d.log);
        } else {
          const maxWeight = Math.max(this.packages.map( p => p.weight ));
          const maxDimension = Math.max(...this.packages.map( p => p.dimensions ).reduce( (acc, val) => acc.concat(val), []));
          const services = this.workareaShippingServices;
          const today = new Date().getDay();
          const hour = new Date().getHours();

          d.shipment_ids.forEach( (e) => this.shipment_ids.push(e))
          if (services) {
            d.rates.forEach( rate => {
              let webRates = services.filter( w => w.service_code === rate.code )
              if (webRates.length > 1) {
                let filter2 = webRates.filter(w => w.name == rate.service)
                if (filter2.length != 1) {
                  console.warn("Found a weird matching service/carrier. Please look into this!", rate, webRates)
                } else {
                  webRates = filter2
                }
              }
              if (webRates.length > 0) {
                webRates.forEach( webRate => {
                  let r = JSON.parse(JSON.stringify(rate));
                  if(
                    webRate.active &&
                    (webRate.max_weight < 1 || maxWeight < webRate.max_weight) &&
                    (webRate.max_dimension < 1 || maxDimension < webRate.max_dimension) &&
                    (
                      (
                        !webRate.timeband_start_day &&
                        !webRate.timeband_end_day
                      ) ||
                      (
                        webRate.timeband_start_day == webRate.timeband_end_day &&
                        today == webRate.timeband_start_day &&
                        hour >= webRate.timeband_start_hour &&
                        hour < webRate.timeband_end_hour
                      ) ||
                      (
                        webRate.timeband_start_day != webRate.timeband_end_day &&
                        (
                          (
                            today == webRate.timeband_start_day &&
                            hour >= webRate.timeband_start_hour
                          ) ||
                          (
                            today == webRate.timeband_end_day &&
                            hour < webRate.timeband_end_hour
                          ) ||
                          (
                            today < webRate.timeband_end_day &&
                            today > webRate.timeband_start_day
                          )
                        )
                      )
                    )
                  ) {
                    if(webRate.calculation_mode === 'discounted') {
                      r.quote.web = r.quote.discount * (1 + (+webRate.calculation_x / 100.0));
                    }else if(webRate.calculation_mode === 'retail') {
                      r.quote.web = r.quote.retail * (1 + (+webRate.calculation_x / 100.0));
                    }else if(webRate.calculation_mode === 'discountOver') {
                      let attempt = r.quote.retail - (r.quote.retail * +webRate.calculation_x / 100);
                      if(attempt > r.quote.discount * (1 + +webRate.calculation_y / 100)) {
                        r.quote.web = attempt;
                      } else {
                        r.quote.web = r.quote.discount * (1 + +webRate.calculation_y / 100);
                      }
                    }else if(webRate.calculation_mode === 'split') {
                      r.quote.web = (r.quote.discount + r.quote.retail) / 2 + ((r.quote.retail - (r.quote.retail+r.quote.discount)/2) * webRate.calculation_x / 100)
                    }else if(webRate.calculation_mode === 'flat') {
                      r.quote.web = webRate.rates[0].price.cents / 100;
                      if (webRate.name === "USPS Small Flat Rate") {
                        r.quote.discount = SMALL_FLAT_RATE_DISCOUNT
                        r.quote.retail = SMALL_FLAT_RATE_RETAIL
                      }
                    }else if(webRate.calculation_mode === 'weightBased') {
                      r.quote.web = this.packages.map(p => p.weight).reduce( (a, v) => a + v, 0) / 16 * webRate.calculation_y + webRate.calculation_x;
                    }else{
                      r.quote.web = null;
                    }
                    r.service = webRate.name
                    const matches = this.rates.filter( (rate) => rate.service == r.service)
                    /*if(matches[0]) {
                      if(matches[0].quote.web <= r.quote.web && matches[0].service == r.service) {
                        const ix = this.rates.findIndex((rate) => rate.service == matches[0].service);
                        this.rates.splice(ix, 1);
                        this.rates.push(r);
                      }
                    } else { */
                      this.rates.push(r);
                    //}
                  }
                });
              } else {
                rate.quote.web = null;
                this.rates.push(rate)
              }
            });
            this.rates.sort( (a,b) => (a.quote.web ? a.quote.web : 9999999) < (b.quote.web ? b.quote.web : 9999999) ? -1 : 1 );
          }
        }
        this.amILoading = false;
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Rates.vue